import { render, staticRenderFns } from "./PostTags.vue?vue&type=template&id=d7c3e528&scoped=true"
import script from "./PostTags.vue?vue&type=script&lang=js"
export * from "./PostTags.vue?vue&type=script&lang=js"
import style0 from "./PostTags.vue?vue&type=style&index=0&id=d7c3e528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c3e528",
  null
  
)

export default component.exports